import React, { useEffect, useState } from "react";
import { Header } from "./containers/Header";
import { Footer } from "./containers/Footer";
import {
  Creator,
  OrderConfirmation,
  OrderDistributor,
  OrderForm,
  OrderServices,
  ProjectHistory,
  ProjectsCart,
} from "./containers/Page";
import { Switch, useLocation, Route } from "react-router-dom";
import {
  CSSTransition,
  SwitchTransition,
  TransitionGroup,
} from "react-transition-group";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { ProjectActions } from "./reducers/project/actionsNames";
import { IProject } from "./reducers/project";
import { useFetch } from "./hooks/useFetch";
import content, { IContent } from "./content";
import { Desktop, useDesktop } from "./components/Responsive";


export function AppLoad({children}) {
  const [_content, requestContent] = useFetch<IContent[]>(
    "/content/",
    {} as any,
    {
      method: "GET",
      body: null,
    }
  );


  useEffect(() => {
    requestContent().then((r) => {
      content.setContent(r);
    });
  }, []);

  return _content? <>{children}</>: <></>
}

function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [_, request] = useFetch<IProject>("/project/", {} as any, {
    method: "GET",
    body: null,
  });

  const desktop = useDesktop();


  const [_cart, requestCart] = useFetch<{
    id: string;
    projects: IProject[];
  }>("/cart/", {} as any, {
    method: "GET",
    body: null,
  });


  useEffect(() => {
    const history = window.localStorage.getItem("history");
    const cart = window.localStorage.getItem("cart");

    if (history) {
      const h: IProject[] = JSON.parse(history);

      h.map(async (h) => {
        const r = await request({}, h.id);
      });
      dispatch({
        type: ProjectActions.LoadHistory,
        history: h,
      });
    }

    if (cart) {
      requestCart({}, cart).then((c) => {
        dispatch({ type: ProjectActions.UpdateCart, cart: c });
      });
    }
  }, []);

  useEffect(() => {
    dispatch({ type: ProjectActions.SetLoaded, loaded: false });
  }, [location.key]);

  return (
    <div
      style={{ display: "flex", height: "100vh", flexDirection: "column" }}
    >
      <Header />
      <Fade desktop={desktop}>
        <SwitchTransition>
          <CSSTransition
            key={location.key || "location"}
            timeout={{ enter: 300, exit: 0 }}
            classNames={"fade"}
          >
            <div style={{ height: "100%" }}>
              <Switch location={location}>
                <Route exact={true} path={"/"} component={Creator} />
                <Route exact={true} path={"/cart"} component={ProjectsCart} />
                <Route
                  exact={true}
                  path={"/history"}
                  component={ProjectHistory}
                />
                <Route exact={true} path={"/order"} component={OrderForm} />
                <Route
                  exact={true}
                  path={"/distributor"}
                  component={OrderDistributor}
                />
                <Route
                  exact={true}
                  path={"/confirmation"}
                  component={OrderConfirmation}
                />
                <Route
                  exact={true}
                  path={"/services"}
                  component={OrderServices}
                />
                <Route exact={true} path={"/:id"} component={Creator} />
              </Switch>
            </div>
          </CSSTransition>
        </SwitchTransition>
      </Fade>
      <Desktop>
        <Footer />
      </Desktop>
    </div>
  );
}

const Fade = styled.div<{ desktop?: boolean }>`
  height: calc(100vh - ${({ desktop }) => (desktop ? "62" : "75")}px);
  .fade-enter {
    opacity: 0.2;
  }

  .fade-enter.fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }

  .fade-exit {
    opacity: 1;
  }

  .fade-exit.fade-exit-active {
    opacity: 0.2;
    transition: opacity 300ms ease-in;
  }
`;

export default App;
